const UserGenerated = '4df80dae-c077-4ffd-8e06-151d7a249eb5'
const ReportGenerated = 'e64fff31-06ea-4fa4-9fed-9c9041c44657'
const UploadedFile ='9ea52a86-6781-42ab-9bfa-5c988a47a94e'

export { UserGenerated, ReportGenerated, UploadedFile}